<style lang="scss" scoped>
.order-slideout {
    width: 100vw;
    height: 100vh;
    position: fixed;
    pointer-events: none;
    top: 0;
    left: 0;
    z-index: 10000;
    &.open {
        pointer-events: all;
        backdrop-filter: saturate(100%) blur(10px);
    }
    .slideout {
        position: fixed;
        width: 720px;
        right: -720px;

        height: 100%;
        opacity: 0;
        top: 0;
        background: #fff;
        box-shadow: 0 0 32px 0 rgba(0, 0, 0, 0.3);
        transition: right 0.15s ease-in-out, opacity 0.15s ease-in-out;
        overflow-y: auto;
        overflow-x: hidden;
        @media screen and (max-width: 720px) {
            width: 100%;
            right: -100%;
        }
        .close {
            position: absolute;
            width: 15px;
            height: 15px;
            right: 40px;
            top: 40px;
            cursor: pointer;
            &:before,
            &:after {
                content: "";
                background: #cccccc;
                position: absolute;
                width: 15px;
                height: 3px;
                border-radius: 2px;
                left: 0;
                transform-origin: left;
                transition: background 0.15s ease-in-out;
            }
            &:before {
                top: 1px;
                transform: rotate(45deg);
            }
            &:after {
                bottom: 0;
                transform: rotate(-45deg);
            }
            &:hover {
                &:before,
                &:after {
                    background: var(--dark);
                }
            }
        }
    }
    &.open {
        .slideout {
            right: 0;
            opacity: 1;
        }
    }
}
::v-deep .order-card {
    @media screen and (max-width: 720px) {
        width: 100%;
        .order-image {
            height: 180px;
        }
    }
}

::v-deep .order-form, ::v-deep .tribe-box-form {
    border: none;
    .form-footer {
        position: sticky;
        bottom: 0;
        z-index: 1;
        background: #fff;
        border-top: 1px solid #cccccc;
        left: 0;
        padding: 24px 40px;
        width: calc(100% + 80px) !important;
        margin-left: -40px;
    }
}
</style>

<template>
    <div class="order-slideout" @click="toggleSlideout" :class="{ open: open }">
        <div class="slideout pt-24 pt-lg-40" @click.stop>
            <div class="close" @click="toggleSlideout"></div>
            <h3 class="px-24 px-lg-40 mb-40">Offerte aanvragen</h3>
            <el-orders v-model="abstractOrders" class="px-24 px-lg-40 mb-16" :canDelete="false"></el-orders>
            <el-orders-form v-if="formType == null || formType == 'general'" class="px-24 px-lg-40 mb-0" :orders="orders" :copy-config="copyConfig"></el-orders-form>
            <el-tribe-box-form v-if="formType == 'tribeBoxes'" class="px-24 px-lg-40 mb-0" :orders="orders" :copy-config="copyConfig"></el-tribe-box-form>
        </div>
    </div>
</template>

<script>
import { bus } from '@/app';
import abstractOrders from "../mixins/abstract-orders";

export default {
    mixins: [abstractOrders],

    data: (vm) => ({
        open: false,
        formType: 'general',
        orders: {
            activities: [],
        }
    }),

    props: {
        copyConfig: {
            type: Object,
            required: true,
        },
    },

    mounted() {
        const self = this;
        bus.$on('orderSlideout', (args) => {
            self.orders = args.orders;
            if (args.formType != null) self.formType = args.formType;
            self.abstractOrders = self.getAbstractOrderObjects(self.orders);
            self.open = true;
        });
    },

    methods: {
        toggleSlideout() {
            this.$root.slideoutIsOpen = !this.$root.slideoutIsOpen;
            this.open = !this.open;
        },
    }
}
</script>